var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCatalogueDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 34,
    viewBox: "0 0 27 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.125V4C15.8599 4.12633 16.1144 4.26529 16.2633 4.41689L22.0904 10.3481C22.2394 10.4997 22.3759 10.7586 22.5 11.125H15.5Z",
    fill: "#007882"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 0.125C2.47989 0.125 1.62145 0.480579 0.988514 1.11351C0.355579 1.74645 0 2.60489 0 3.5V30.5C0 31.3951 0.355579 32.2536 0.988514 32.8865C1.62145 33.5194 2.47989 33.875 3.375 33.875H23.625C24.5201 33.875 25.3785 33.5194 26.0115 32.8865C26.6444 32.2536 27 31.3951 27 30.5V13.3348C26.9998 12.4397 26.6441 11.5814 26.0111 10.9486L16.1764 1.11387C15.5436 0.480896 14.6853 0.125191 13.7902 0.125H3.375ZM2.53125 3.5C2.53125 3.27622 2.62014 3.06161 2.77838 2.90338C2.93661 2.74514 3.15122 2.65625 3.375 2.65625H13.5V10.25C13.5 11.1451 13.8556 12.0035 14.4885 12.6365C15.1215 13.2694 15.9799 13.625 16.875 13.625H24.4688V30.5C24.4688 30.7238 24.3799 30.9384 24.2216 31.0966C24.0634 31.2549 23.8488 31.3438 23.625 31.3438H3.375C3.15122 31.3438 2.93661 31.2549 2.77838 31.0966C2.62014 30.9384 2.53125 30.7238 2.53125 30.5V3.5ZM22.5787 11.0938H16.875C16.6512 11.0938 16.4366 11.0049 16.2784 10.8466C16.1201 10.6884 16.0312 10.4738 16.0312 10.25V4.54625L22.5787 11.0938Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCatalogueDocuments);
export default __webpack_public_path__ + "static/media/file-catalogue-documents.ad7219da08c161cf61425ed95ae3c1c1.svg";
export { ForwardRef as ReactComponent };